// @flow
import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import paymentErrorSVG from '../../../../assets/img/paymentError.svg';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {Typography} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';

import {useHistory} from 'react-router-dom';
import queryString from 'query-string';
import {useState} from 'react';
import {useEffect} from 'react';
import type {Store, User} from '../../../../entities';
import analytics from '../../../../analytics';
import {connect} from 'react-redux';
import type {RootState} from '../../..';
import {TIENDADA_LINKS} from '../../../../constants';
import {useSafePrevious} from '../../../../utils/react';

type Props = {
  store?: Store,
  open?: boolean,
  handleClose?: () => void,
  error?: string,
  user?: User,
  programaticallyShowError?: boolean,
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 592,
    maxWidth: '100%',
    padding: theme.spacing(5, 0),
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
    marginTop: theme.spacing(2),
  },
  text: {
    marginTop: theme.spacing(3),
    color: colors.grey800,
    fontSize: '1.125rem',
  },
  button: {
    height: 48,
    // borderRadius: '8px',
    marginTop: theme.spacing(3),
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: '4px 36px',
  },
  secondButton: {
    marginTop: theme.spacing(1),
  },
}));

function PaymentFailureModal(props: Props) {
  const {
    store,
    open = false,
    handleClose,
    error,
    user,
    programaticallyShowError = false,
  } = props;

  const previousOpen = useSafePrevious(open);
  const classes = useStyles();

  const history = useHistory();

  const queryObject = queryString.parse(history.location.search);

  const [paymentFailureModalOpen, setPaymentFailureModalOpen] = useState(open);
  const [paymentFailureError, setPaymentFailureError] = useState(error);

  const handleClosePaymentFailureModal = () => {
    if (handleClose) handleClose();
    history.replace({search: ''});
    setPaymentFailureModalOpen(false);
  };

  const shouldProgramaticallyOpen =
    programaticallyShowError && !previousOpen && open;

  useEffect(() => {
    if (
      // Stripe custom implementation
      queryObject.payment_intent &&
      queryObject.payment_intent_client_secret &&
      (queryObject.redirect_status === 'requires_payment_method' ||
        queryObject.redirect_status === 'failed')
    ) {
      setPaymentFailureModalOpen(true);
      setPaymentFailureError(
        'Pago fallido. Por favor intente con otro método de pago'
      );
    }
  }, [
    queryObject.payment_intent,
    queryObject.payment_intent_client_secret,
    queryObject.redirect_status,
  ]);

  useEffect(() => {
    if (
      (paymentFailureModalOpen || shouldProgramaticallyOpen) &&
      user &&
      store
    ) {
      analytics.fireCustomEvent('Pro Plan Payment Failed', {
        category: 'Subscription',
        action: 'Failed',
        user_type: user.type,
        store_tier_id: store.storeTier.name,
      });
    }
  }, [paymentFailureModalOpen, shouldProgramaticallyOpen, store, user]);

  useEffect(() => {
    if (shouldProgramaticallyOpen) {
      setPaymentFailureModalOpen(true);
      setPaymentFailureError(
        'Pago fallido. Por favor intente con otro método de pago'
      );
    }
  }, [shouldProgramaticallyOpen]);

  return (
    <CustomModal
      open={paymentFailureModalOpen}
      handleCloseModal={handleClosePaymentFailureModal}
    >
      <div className={classes.root}>
        <img src={paymentErrorSVG} alt="" />
        <Typography className={classes.title} align="center">
          ¡Ooops hubo un problema con su pago!
        </Typography>
        <Typography className={classes.text} align="center">
          Se ha detectado un problema con su pago:
          <br /> {paymentFailureError}
        </Typography>
        <CustomButton
          variant="contained"
          className={classes.button}
          onClick={handleClosePaymentFailureModal}
        >
          Volver a intentar
        </CustomButton>
        <CustomButton
          className={classes.secondButton}
          href={TIENDADA_LINKS.customerSupport.general}
          target="_blank"
          rel="noopener noreferrer"
        >
          Contáctate con TiendaDa
        </CustomButton>
      </div>
    </CustomModal>
  );
}

export default connect((state: RootState) => ({
  store: state.store.store,
  user: state.auth.user,
}))(PaymentFailureModal);

PaymentFailureModal.propTypes = {
  store: PropTypes.object,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  error: PropTypes.string,
  user: PropTypes.object,
};
